import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useRef } from "react";
import jsPDF from "jspdf";

const SYLLABUS = [
  {
    class: "9th",
    subjects: [
      {
        name: "Mathematics",
        syllabusLink: "/dummydata/67-S-3 ACCOUNTANCY.pdf",
        chapters: [
          "Number Systems",
          "Polynomials",
          "Linear Equations in Two Variables",
          "Lines and Angles",
          "Triangles",
        ],
      },
      {
        name: "Science",
        syllabusLink: "/dummydata/67-S-3 ACCOUNTANCY.pdf",
        chapters: [
          "Matter in Our Surroundings",
          "Is Matter Around Us Pure?",
          "Atoms and Molecules",
          "Motion",
          "Force and Laws of Motion",
        ],
      },
      {
        name: "English",
        syllabusLink: "/dummydata/67-S-3 ACCOUNTANCY.pdf",
        chapters: [
          "The Fun They Had",
          "The Sound of Music",
          "The Little Girl",
          "A Truly Beautiful Mind",
        ],
      },
    ],
  },
  {
    class: "10th",
    subjects: [
      {
        name: "Mathematics",
        syllabusLink: "/dummydata/67-S-3 ACCOUNTANCY.pdf",
        chapters: [
          "Real Numbers",
          "Polynomials",
          "Quadratic Equations",
          "Arithmetic Progressions",
          "Coordinate Geometry",
        ],
      },
      {
        name: "Science",
        syllabusLink: "/dummydata/67-S-3 ACCOUNTANCY.pdf",
        chapters: [
          "Chemical Reactions and Equations",
          "Acids, Bases and Salts",
          "Metals and Non-Metals",
          "Life Processes",
          "Control and Coordination",
        ],
      },
      {
        name: "English",
        syllabusLink: "/dummydata/67-S-3 ACCOUNTANCY.pdf",
        chapters: [
          "A Letter to God",
          "Nelson Mandela",
          "Two Stories about Flying",
          "From the Diary of Anne Frank",
        ],
      },
    ],
  },
  {
    class: "12th",
    subjects: [
      {
        name: "Physics",
        syllabusLink: "/dummydata/67-S-3 ACCOUNTANCY.pdf",
        chapters: [
          "Electric Charges and Fields",
          "Current Electricity",
          "Moving Charges and Magnetism",
          "Electromagnetic Induction",
          "Alternating Current",
        ],
      },
      {
        name: "Chemistry",
        syllabusLink: "/dummydata/67-S-3 ACCOUNTANCY.pdf",
        chapters: [
          "The Solid State",
          "Solutions",
          "Electrochemistry",
          "Chemical Kinetics",
          "Surface Chemistry",
        ],
      },
      {
        name: "Biology",
        syllabusLink: "/dummydata/67-S-3 ACCOUNTANCY.pdf",
        chapters: [
          "Reproduction in Organisms",
          "Genetics and Evolution",
          "Human Health and Disease",
          "Biotechnology",
        ],
      },
    ],
  },
];

const PAPERS = [
  {
    class: "10th",
    subjects: {
      Mathematics: [
        { title: "Mathematics 2024", pdfUrl: "/dummydata/67-S-3 ACCOUNTANCY.pdf" },
        { title: "Mathematics 2023", pdfUrl: "/dummydata/67-S-3 ACCOUNTANCY.pdf" },
        { title: "Mathematics 2022", pdfUrl: "/dummydata/67-S-3 ACCOUNTANCY.pdf" },
        { title: "Mathematics 2021", pdfUrl: "/dummydata/67-S-3 ACCOUNTANCY.pdf" },
      ],
      Science: [
        { title: "Science 2024", pdfUrl: "/dummydata/67-S-3 ACCOUNTANCY.pdf" },
        { title: "Science 2023", pdfUrl: "/dummydata/67-S-3 ACCOUNTANCY.pdf" },
        { title: "Science 2022", pdfUrl: "/dummydata/67-S-3 ACCOUNTANCY.pdf" },
      ],
      English: [
        { title: "English 2024", pdfUrl: "/dummydata/67-S-3 ACCOUNTANCY.pdf" },
        { title: "English 2023", pdfUrl: "/dummydata/67-S-3 ACCOUNTANCY.pdf" },
      ],
    },
  },
  {
    class: "12th",
    subjects: {
      Physics: [
        { title: "Physics 2024", pdfUrl: "/dummydata/67-S-3 ACCOUNTANCY.pdf" },
        { title: "Physics 2023", pdfUrl: "/dummydata/67-S-3 ACCOUNTANCY.pdf" },
        { title: "Physics 2022", pdfUrl: "/dummydata/67-S-3 ACCOUNTANCY.pdf" },
      ],
      Chemistry: [
        { title: "Chemistry 2024", pdfUrl: "/dummydata/67-S-3 ACCOUNTANCY.pdf" },
        { title: "Chemistry 2023", pdfUrl: "/dummydata/67-S-3 ACCOUNTANCY.pdf" },
      ],
      Biology: [
        { title: "Biology 2024", pdfUrl: "/dummydata/67-S-3 ACCOUNTANCY.pdf" },
        { title: "Biology 2023", pdfUrl: "/dummydata/67-S-3 ACCOUNTANCY.pdf" },
        { title: "Biology 2022", pdfUrl: "/dummydata/67-S-3 ACCOUNTANCY.pdf" },
        { title: "Biology 2021", pdfUrl: "/dummydata/67-S-3 ACCOUNTANCY.pdf" },
      ],
    },
  },
];


export default function SyllabusSection() {
  const [selectedClass, setSelectedClass] = useState("9th");
  const [openAccordions, setOpenAccordions] = useState({});
  const [openPaper, setOpenPaper] = useState({});

  const toggleAccordion = (subjectName) => {
    setOpenAccordions((prev) => ({
      ...prev,
      [subjectName]: !prev[subjectName],
    }));
  };

  const togglePaper = (subjectName) => {
    setOpenPaper((prev) => ({
      ...prev,
      [subjectName]: !prev[subjectName],
    }));
  };

  const currentClass = SYLLABUS.find((item) => item.class === selectedClass);
  const paperData = PAPERS.find((item) => item.class === selectedClass);

   const printRef = useRef();


const handleDownloadPdf = () => {
  if (!currentClass) return;

  const doc = new jsPDF();
  let y = 10;

  // Class Title
  doc.setFontSize(14);
  doc.text(`Class: ${currentClass.class}`, 10, y);
  y += 10;

  currentClass.subjects.forEach((subject, index) => {
    doc.setFontSize(12);
    doc.text(`${index + 1}. ${subject.name}`, 10, y);
    y += 8;

   
    if (subject.syllabusLink) {
      doc.setFontSize(10);
      doc.text(`Syllabus File: ${subject.syllabusLink}`, 15, y);
      y += 6;
    }

   
    subject.chapters.forEach((chapter) => {
      doc.setFontSize(11);
      doc.text(`- ${chapter}`, 20, y);
      y += 6;

   
      if (y > 280) {
        doc.addPage();
        y = 10;
      }
    });

    y += 5; 
  });

 
  doc.save(`${currentClass.class}_Syllabus.pdf`);
};



  return (
    <div className="p-4 max-w-5xl mx-auto">
      <h2 className="text-3xl font-bold text-center mb-6">Class-wise Syllabus</h2>

      <div className="flex justify-center gap-2 flex-wrap mb-6">
        {SYLLABUS.map((item) => (
          <button
            key={item.class}
            onClick={() => setSelectedClass(item.class)}
            className={`px-4 py-2 rounded-full border text-sm font-medium transition-all duration-300 shadow-sm ${
              selectedClass === item.class
                ? "bg-blue-600 text-white"
                : "bg-white text-gray-700 hover:bg-gray-100"
            }`}
          >
            Class {item.class}
          </button>
        ))}
      </div>

      {/* Syllabus Cards */}
        <div>
      <button
        onClick={handleDownloadPdf}
        className="mb-4 rounded bg-blue-600 px-4 py-2 text-white"
      >
        📥 Download Syllabus as PDF
      </button>

      <div ref={printRef} className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10">
        {currentClass.subjects.map((subject) => (
          <div key={subject.name} className="bg-white rounded-2xl shadow-md p-4 border">
            <h3 className="text-lg font-semibold mb-2">{subject.name}</h3>

            <button
              onClick={() => toggleAccordion(subject.name)}
              className="text-sm text-blue-600 hover:underline"
            >
              {openAccordions[subject.name] ? "Hide Chapters" : "View Chapters"}
            </button>

            <AnimatePresence>
              {openAccordions[subject.name] && (
                <motion.ul
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  className="mt-3 overflow-hidden text-sm list-disc list-inside space-y-1"
                >
                  {subject.chapters.map((chapter, i) => (
                    <li key={i}>{chapter}</li>
                  ))}
                </motion.ul>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
    </div>
      {/* Previous Year Papers */}
      {(selectedClass === "10th" || selectedClass === "12th") && paperData && (
        <div>
          <h2 className="text-2xl font-semibold text-center mb-4">Previous Year Papers</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {Object.entries(paperData.subjects).map(([subject, papers]) => (
              <div key={subject} className="bg-gray-50 p-4 rounded-xl border">
                <h4 className="font-medium text-lg mb-2">{subject}</h4>

                <button
                  onClick={() => togglePaper(subject)}
                  className="text-sm text-blue-600 hover:underline"
                >
                  {openPaper[subject] ? "Hide Papers" : "View Papers"}
                </button>

                <AnimatePresence>
                  {openPaper[subject] && (
                    <motion.ul
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      className="mt-3 overflow-hidden text-sm list-disc list-inside space-y-1"
                    >
                      {papers.map((paper, i) => (
                        <li key={i}>
                          <a
                            href={paper.pdfUrl}
                            download
                            className="text-blue-500 hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            📘 {paper.title}
                          </a>
                        </li>
                      ))}
                    </motion.ul>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
